import { Component, OnInit } from '@angular/core';
import { Globals } from '../_globals';
import { AuthService } from '../_services/auth.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {

  constructor(
    public globals: Globals,
    public authService: AuthService,
    private modalService: NgbModal,
    ) {}

  ngOnInit() {}

    // Modal
    public openChangePassword() {
      const modalOptions: NgbModalOptions = { centered: true, backdrop: 'static', keyboard: false };
      const modal = this.modalService.open(ChangePasswordModalComponent, modalOptions);
    }

}
